import { StyleSheet } from 'react-native';
import theme from '../../../common/theme';
import { themeType } from '../../../common/theme-colors';

export const makeStyles = (colors: themeType) =>
  StyleSheet.create({
    container: {
      width: 700,
      maxWidth: '90%',
      alignSelf: 'center',
    },
    content: {
      padding: 30,
      marginTop: 8,
      borderRadius: theme.radius.medium,
      backgroundColor: colors.popupBg,
      ...theme.shadow.strong,
    },
    description: {
      fontSize: theme.fontSize.small,
      color: colors.textLight,
      marginBottom: 20,
      lineHeight: 24,
    },
    list: {
      maxHeight: 500,
    },
    rows: {
      rowGap: 8,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 20,
      borderRadius: theme.radius.small,
      borderWidth: 2,
      minHeight: 90,
    },
    screenInfo: {
      flex: 1,
      rowGap: 6,
    },
    screenName: {
      fontSize: theme.fontSize.medium,
      fontWeight: '600',
      color: colors.text,
      fontFamily: theme.fonts.medium,
    },
    screenDetails: {
      fontSize: theme.fontSize.xs,
      color: colors.textLight,
      fontFamily: theme.fonts.regular,
    },
    badgeContainer: {
      flexDirection: 'row',
      columnGap: 6,
      marginTop: 6,
    },
    badge: {
      backgroundColor: colors.popupBg,
      paddingHorizontal: 8,
      paddingVertical: 4,
      borderRadius: 4,
      borderWidth: 1,
      borderColor: colors.borderColor,
    },
    badgeText: {
      fontSize: 11,
      color: colors.textLight,
      fontWeight: '500',
      fontFamily: theme.fonts.medium,
    },
    icon: {
      width: 24,
      height: 24,
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: 16,
    },
    emptyContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: 40,
      minHeight: 200,
    },
    emptyText: {
      fontSize: theme.fontSize.medium,
      color: colors.textLight,
      textAlign: 'center',
      fontFamily: theme.fonts.regular,
    },
    errorContainer: {
      backgroundColor: colors.redLightest,
      borderRadius: theme.radius.small,
      padding: 16,
      marginBottom: 16,
      borderWidth: 1,
      borderColor: colors.red,
    },
    errorText: {
      fontSize: theme.fontSize.small,
      color: colors.red,
      textAlign: 'center',
      fontFamily: theme.fonts.medium,
      fontWeight: '600',
    },
  });
